import React from "react";
import "./achievements.css";
import Separator from "../../common/separator";
import { AchievementsData } from "../../data/achievements";
import AchievementCard from "./achievement-card";

function Achievements() {
  const data = AchievementsData;
  return (
    <div className="achievements">
      <Separator />
      <label className="section-title">Achievements</label>
      <div className="achievements-list">
        {data.map((item) => {
          return <AchievementCard item={item} key={item.id} />;
        })}
      </div>
    </div>
  );
}

export default Achievements;
